/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Lembaga_P3dInputs */

const en_mk_sol_lembaga_p3d = /** @type {(inputs: Mk_Sol_Lembaga_P3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A single wrong sentence can cost trust, so nobody dares write quickly.`)
};

const id_mk_sol_lembaga_p3d = /** @type {(inputs: Mk_Sol_Lembaga_P3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satu kalimat yang keliru bisa berdampak pada kepercayaan; karena itu tidak ada yang berani menulis cepat.`)
};

/**
* | output |
* | --- |
* | "A single wrong sentence can cost trust, so nobody dares write quickly." |
*
* @param {Mk_Sol_Lembaga_P3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_lembaga_p3d = /** @type {((inputs?: Mk_Sol_Lembaga_P3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Lembaga_P3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_lembaga_p3d(inputs)
	return en_mk_sol_lembaga_p3d(inputs)
});